import * as R from 'ramda'

export const isFeatureEnabled = id =>
  R.pipe(R.find(R.propEq('id', id)), R.prop('enabled'), R.defaultTo(false))
